<template>
  <div class="container">
    <h1 class="titulo text-center">RESERVACIONES</h1>

    <div class="row mb-3">
      <div class="col-md-2">
        <label for="fechaInicio" class="form-label">Fecha Inicio</label>
        <input
          v-model="filtro.fechaInicio"
          type="date"
          id="fechaInicio"
          class="form-control"
        />
      </div>
      <div class="col-md-2">
        
        <label for="fechaFin" class="form-label">Fecha Fin</label>
        <input
          v-model="filtro.fechaFin"
          type="date"
          id="fechaFin"
          class="form-control"
        />
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button class="btn btn-info w-100 me-2" @click="cargarDatos">
    <i class="bi bi-arrow-repeat"></i> 
     </button>
        <button class="btn btn-primary w-100 me-2" @click="filtrarPorFechas">
          <i class="bi bi-search"></i> Buscar
        </button>
        <button class="btn btn-secondary w-100 ms-2" @click="mostrarTodas">
          <i class="bi bi-arrow-clockwise"></i> Mostrar Todas
        </button>
        <button class="btn btn-primary w-100 ms-2" @click="verNuevasReservaciones">
          <i class="bi bi-search"></i> Ver Nuevas
        </button>
        <button class="btn btn-primary w-100 ms-2" @click="verPendientesReservaciones">
          <i class="bi bi-search"></i> Pendientes
        </button>
        <input
          v-model="searchQuery"
          type="text"
          class="form-control w-100 ms-2"
          placeholder="Buscar"
        />
      </div>
    </div>

    <div class="table-container">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Folio</th>
            <th>Correo</th>
            <th>Cliente</th>
            <th>Origen</th>
            <th>Destino</th>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Total personas</th>
            <th>Adultos</th>
            <th>Niños</th>
            <th>Total pago</th>
            <th>Estatus del pago</th>
            <th>Conductor</th>
            <th>Auto</th>
            <th>Estatus de la reservación</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reservacion in paginatedReservaciones" :key="reservacion.IdRegistro">
            <td>{{ reservacion.Folio }}</td>
            <td>{{ reservacion.Correo }}</td>
            <td>{{ reservacion.Cliente }}</td>
            <td>{{ reservacion.Origen }}</td>
            <td>{{ reservacion.Destino }}</td>
            <td>{{ reservacion.FechaReservacion }}</td>
            <td>{{ reservacion.HoraReservacion }}</td>
            <td>{{ reservacion.TotalPasajeros }}</td>
            <td>{{ reservacion.Adultos }}</td>
            <td>{{ reservacion.Ninos }}</td>
            <td>{{ reservacion.Total }}</td>
            <td>{{ reservacion.EstatusPago }}</td>
            <td>
              <span v-if="!reservacion.editandoConductor">
                {{ reservacion.NombreConductor || "No asignado" }}
                <button class="icon-button" @click="habilitarEdicion('conductor', reservacion)">
                  <i class="bi bi-pencil-square"></i>
                </button>
              </span>
              <select
                v-if="reservacion.editandoConductor"
                v-model="reservacion.Id_conductor"
                @change="actualizarConductor(reservacion)"
              >
                <option v-for="conductor in conductores" :key="conductor.Id_conductor" :value="conductor.Id_conductor">
                  {{ conductor.Nombre }}
                </option>
              </select>
            </td>
            <td>
              <span v-if="!reservacion.editandoAuto">
                {{ reservacion.ModeloAuto || "No asignado" }}
                <button class="icon-button" @click="habilitarEdicion('auto', reservacion)">
                  <i class="bi bi-pencil-square"></i>
                </button>
              </span>
              <select
                v-if="reservacion.editandoAuto"
                v-model="reservacion.Id_auto"
                @change="actualizarAuto(reservacion)"
              >
                <option v-for="auto in autos" :key="auto.Id_auto" :value="auto.Id_auto">
                  {{ auto.Modelo }}
                </option>
              </select>
            </td>
            <td>
              <span v-if="!reservacion.editandoEstatus">
                {{ reservacion.Estatus }}
                <button class="icon-button" @click="habilitarEdicion('estatus', reservacion)">
                  <i class="bi bi-pencil-square"></i>
                </button>
              </span>
              <select
                v-if="reservacion.editandoEstatus"
                v-model="reservacion.Estatus"
                @change="actualizarEstatus(reservacion)"
              >
                <option v-for="estatus in estatusOptions" :key="estatus" :value="estatus">
                  {{ estatus }}
                </option>
              </select>
           <p></p>   
                <button class="icon-button" @click="enviarCorreo(reservacion)" title="Confirmar por correo dispinibilidad"> 📩 </button>
                <button class="icon-button" @click="confirmarReservacionExitosa(reservacion)" title="Confirmar reservación exitosa">✅</button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación -->
      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
          </li>
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              Siguiente
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  data() {
    return {
      reservaciones: [], // Lista completa de reservaciones
      conductores: [],
      autos: [],
      estatusOptions: ["Nuevo", "Pendiente", "Confirmada", "Exitosa"], // Opciones del estatus
      filtro: { fechaInicio: "", fechaFin: "" },
      searchQuery: "",
      currentPage: 1, // Página actual
      itemsPerPage: 8, // Número de ítems por página
    };
  },
  computed: {
    filteredReservaciones() {
      if (!this.searchQuery) {
        return this.reservaciones;
      }
      const query = this.searchQuery.toLowerCase();
      return this.reservaciones.filter((reservacion) => {
        return (
          reservacion.Cliente.toLowerCase().includes(query) ||
          reservacion.Folio.toLowerCase().includes(query) ||
          reservacion.Origen.toLowerCase().includes(query) ||
          reservacion.Destino.toLowerCase().includes(query)
        );
      });
    },
    paginatedReservaciones() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredReservaciones.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredReservaciones.length / this.itemsPerPage);
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    async cargarDatos() {
      try {
        const { data: reservaciones } = await axios.get(
         this.$backendUrl+ "/index.php/reservaciones/lista_completa"
        );
        this.reservaciones = reservaciones.map((reservacion) => ({
          ...reservacion,
          editandoConductor: false,
          editandoAuto: false,
          editandoEstatus: false,
        }));
        const [conductoresRes, autosRes] = await Promise.all([
          axios.get(this.$backendUrl+ "/index.php/conductores/lista_completa"),
          axios.get(this.$backendUrl+ "/index.php/autos/lista_completa"),
        ]);
        this.conductores = conductoresRes.data;
        this.autos = autosRes.data;
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    },
    habilitarEdicion(tipo, reservacion) {
      reservacion[`editando${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`] = true;
    },
    async actualizarConductor(reservacion) {
      try {
        await axios.post(this.$backendUrl+ "/index.php/reservaciones/asignar_conductor_auto", {
          IdRegistro: reservacion.IdRegistro,
          Id_conductor: reservacion.Id_conductor,
        });
        reservacion.editandoConductor = false;
        const conductor = this.conductores.find((c) => c.Id_conductor === reservacion.Id_conductor);
        reservacion.NombreConductor = conductor ? conductor.Nombre : "No asignado";
        Swal.fire("Éxito", "Conductor actualizado correctamente.", "success");
      } catch (error) {
        console.error("Error al actualizar conductor:", error);
        Swal.fire("Error", "Error al actualizar conductor.", "error");
      }
    },
    async actualizarAuto(reservacion) {
      try {
        await axios.post(this.$backendUrl+ "/index.php/reservaciones/asignar_conductor_auto", {
          IdRegistro: reservacion.IdRegistro,
          Id_auto: reservacion.Id_auto,
        });
        reservacion.editandoAuto = false;
        const auto = this.autos.find((a) => a.Id_auto === reservacion.Id_auto);
        reservacion.ModeloAuto = auto ? auto.Modelo : "No asignado";
        Swal.fire("Éxito", "Auto actualizado correctamente.", "success");
      } catch (error) {
        console.error("Error al actualizar auto:", error);
        Swal.fire("Error", "Error al actualizar auto.", "error");
      }
    },
    async actualizarEstatus(reservacion) {
      try {
        await axios.post(this.$backendUrl+ "/index.php/reservaciones/actualizar_estatus", {
          IdRegistro: reservacion.IdRegistro,
          Estatus: reservacion.Estatus,
        });
        reservacion.editandoEstatus = false;
        Swal.fire("Éxito", "Estatus actualizado correctamente.", "success");
      } catch (error) {
        console.error("Error al actualizar el estatus:", error);
        Swal.fire("Error", "Error al actualizar el estatus.", "error");
      }
    },
    async filtrarPorFechas() {
      if (!this.filtro.fechaInicio || !this.filtro.fechaFin) {
        Swal.fire("Advertencia", "Por favor selecciona ambas fechas para filtrar.", "warning");
        return;
      }

      try {
        const { data } = await axios.get(
          this.$backendUrl+ "/index.php/reservaciones/buscar_por_fechas",
          { params: this.filtro }
        );

        this.reservaciones = data.map((reservacion) => ({
          ...reservacion,
          editandoConductor: false,
          editandoAuto: false,
          editandoEstatus: false,
        }));
      } catch (error) {
        Swal.fire("Error", "Error al filtrar reservaciones.", "error");
      }
    },
    async mostrarTodas() {
      this.filtro.fechaInicio = "";
      this.filtro.fechaFin = "";
      await this.cargarDatos();
    },
    async verNuevasReservaciones() {
      try {
        const { data } = await axios.get(
         this.$backendUrl+ "/index.php/reservaciones/lista_completa"
        );
        this.reservaciones = data.filter((reservacion) => reservacion.Estatus === "Nuevo");
      } catch (error) {
        console.error("Error al obtener nuevas reservaciones:", error);
        alert("Error al cargar nuevas reservaciones.");
      }
    },
    async verPendientesReservaciones() {
      try {
        const { data } = await axios.get(
        this.$backendUrl+ "/index.php/reservaciones/lista_completa"
        );
        this.reservaciones = data.filter((reservacion) => reservacion.Estatus === "Pendiente");
      } catch (error) {
        console.error("Error al obtener reservaciones pendientes:", error);
        alert("Error al cargar reservaciones pendientes.");
      }
    },
    async enviarCorreo(reservacion) {
      console.log("Enviando datos al servidor:", reservacion);

      // Validación de datos básicos
      if (!reservacion.IdRegistro || !reservacion.Cliente || !reservacion.Correo || 
        !reservacion.Folio || !reservacion.FechaReservacion || !reservacion.Origen || 
        !reservacion.Destino || !reservacion.Total) {
        alert("Por favor, proporciona todos los datos necesarios para enviar el correo.");
        return;
      }

      try {
        // Enviar la solicitud al backend
        const response = await axios.post(
         this.$backendUrl+ "/index.php/reservaciones/confirmarDisponibilidad",
          {
            IdRegistro: reservacion.IdRegistro,
            Cliente: reservacion.Cliente,
            Correo: reservacion.Correo,
            Folio: reservacion.Folio,
            FechaReservacion: reservacion.FechaReservacion,
            HoraReservacion: reservacion.HoraReservacion,
            Origen: reservacion.Origen,
            Destino: reservacion.Destino,
            Total: reservacion.Total,
          }
        );

        console.log("Respuesta completa del servidor:", response.data);

        // Manejar la respuesta del servidor
        if (response.status === 200 && response.data && response.data.exito) {
          Swal.fire("Éxito", response.data.mensaje, "success");
} else {
    console.error("Respuesta inesperada del servidor:", response);
    Swal.fire("Error", response.data?.mensaje || "Error al enviar el correo.", "error");
}

      } catch (error) {
        // Manejar errores de la solicitud
        if (error.response) {
          console.error("Error del servidor:", error.response.data);
          alert("Error del servidor: " + (error.response.data.mensaje || "No se pudo procesar la solicitud."));
        } else {
          console.error("Error inesperado:", error.message);
          alert("Error inesperado al confirmar la disponibilidad.");
        }
      }
    },
    async confirmarReservacionExitosa(reservacion) {
      console.log("Enviando datos al servidor:", reservacion);

      // Validación de datos básicos
      if (!reservacion.IdRegistro || !reservacion.Cliente || !reservacion.Correo || 
    !reservacion.Folio || !reservacion.FechaReservacion || !reservacion.HoraReservacion || 
    !reservacion.Origen || !reservacion.Destino || !reservacion.NombreConductor || 
    !reservacion.ModeloAuto || !reservacion.Total) {
      Swal.fire("No has asignado conductor o auto en la reservación.");
    return;
      }

      try {
        // Enviar la solicitud al backend
        const response = await axios.post(
        this.$backendUrl+ "/index.php/reservaciones/confirmarReservacion",
          {
            IdRegistro: reservacion.IdRegistro,
            Cliente: reservacion.Cliente,
            Correo: reservacion.Correo,
            Folio: reservacion.Folio,
            FechaReservacion: reservacion.FechaReservacion,
            HoraReservacion: reservacion.HoraReservacion,
            Origen: reservacion.Origen,
            Destino: reservacion.Destino,
            NombreConductor: reservacion.NombreConductor,
            ModeloAuto: reservacion.ModeloAuto,
            Total: reservacion.Total,

          }
        );

        console.log("Respuesta completa del servidor:", response.data);

        // Manejar la respuesta del servidor
        if (response.status === 200 && response.data && response.data.exito) {
          Swal.fire("Éxito", response.data.mensaje, "success");
} else {
    console.error("Respuesta inesperada del servidor:", response);
    Swal.fire("Error", response.data?.mensaje || "Error al confirmar la reservación.", "error");
}

      } catch (error) {
        // Manejar errores de la solicitud
        if (error.response) {
          console.error("Error del servidor:", error.response.data);
          alert("Error del servidor: " + (error.response.data.mensaje || "No se pudo procesar la solicitud."));
        } else {
          console.error("Error inesperado:", error.message);
          Swal.fire("Error", "No se pudo confirmar la reservación.", "error");
        }
      }
    },
  },
  mounted() {
    this.cargarDatos();
  },
};
</script>



<style scoped>
* {
font-size: 13.5px;
}
.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
  border: none;
}

.btn-secondary:hover {
  background-color: #495057;
}
.button{
  margin: 0;
}
/* Estilo para eliminar bordes en los botones */
button.icon-button {
  background: none !important; /* Asegura que el fondo sea transparente */
  border: none !important; /* Asegura que no haya bordes */
  padding: 0 !important; /* Elimina espacios internos */
  margin: 0 !important; /* Elimina márgenes si existen */
  box-shadow: none !important; /* Elimina cualquier sombra */
  cursor: pointer; /* Cambia el cursor para indicar que es clickeable */
}

/* Hover para el botón */
button.icon-button:hover {
  color: #c2185b; /* Un color más oscuro al pasar el cursor */
}

/* Estilo del ícono del lápiz */
button.icon-button i {
  font-size: 1.2rem; /* Ajusta el tamaño del ícono */
  color: #d7246f; /* Color predeterminado del lápiz */
  transition: color 0.3s ease; /* Suaviza el cambio de color */
}

/* Hover para el ícono del lápiz */
button.icon-button:hover i {
  color: #c2185b; /* Cambia el color al pasar el cursor */
}

/* Estilo general para el select */
select {
  background-color: #f8f9fa; /* Fondo claro */
  color: #495057; /* Color del texto */
  border: 1px solid #ced4da; /* Borde gris claro */
  border-radius: 0.375rem; /* Esquinas redondeadas */
  padding: 0.375rem 0.75rem; /* Espaciado interno */
  font-size: 1rem; /* Tamaño de fuente */
  transition: box-shadow 0.2s ease, border-color 0.2s ease; /* Suaviza el hover */
  outline: none; /* Elimina el contorno predeterminado */
}

/* Cambios al pasar el mouse */
select:hover {
  border-color: #80bdff; /* Azul claro */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.25); /* Sombra azul suave */
}

/* Cambios al enfocarse */
select:focus {
  border-color: #007bff; /* Azul intenso */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Sombra azul más intensa */
}

/* Opciones dentro del select */
option {
  padding: 0.5rem; /* Espaciado entre opciones */
  color: #495057; /* Color de texto */
  background-color: #ffffff; /* Fondo blanco */
}
.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349; /* Fondo rosa */
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 35px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; /* Espacio superior e inferior */
}
button.icon-button {
  border: none; /* Elimina los bordes */
  background: none; /* Elimina el fondo */
  cursor: pointer; /* Mantiene el puntero de clic */
  padding: 0; /* Opcional: Ajusta el espacio interno */
}

</style>